export default function apiCall(method, url, options = null) {
  if (options === null) {
    const body = null
    return fetch(url, {
      method,
      body,
    }).then((response) => {

      if (method.toUpperCase() === "DELETE") {
        return response
      }

      const isReportCall = url.includes("/opa-reports") && !url.includes("/opa-reports-template")
      const isUpdatePassw = url.includes("/opa-change-password")

      if (isUpdatePassw) {
        return response.json().then(data => ({
          ...data,
          status: response.status,
          ok: response.ok
        })).catch(error => ({
          status: response.status,
          ok: response.ok,
          error: "Failed to parse response"
        }))
      }

      if (isReportCall) {
        return response
          .text()
          .then((text) => {
            return text
          })
          .catch((error) => {
            return response.json()
          })
      }

      return response.json()
    })
  } else {
    const body = options.body
    const headers = options.headers
    return fetch(url, {
      method,
      headers,
      body,
    }).then((response) => {

      if (method.toUpperCase() === "DELETE") {
        return response
      }

      const isReportCall = url.includes("/opa-reports") && !url.includes("/opa-reports-template")
      const isUpdatePassw = url.includes("/opa-change-password")

      if (isUpdatePassw) {
        return response.json().then(data => ({
          ...data,
          status: response.status,
          ok: response.ok
        })).catch(error => ({
          status: response.status,
          ok: response.ok,
          error: "Failed to parse response"
        }))
      }


      if (isReportCall) {
        return response
          .text()
          .then((text) => {
            return text
          })
          .catch((error) => {
            return response.json()
          })
      }

      return response.json()
    })
  }
}
